import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9f0bb346")

_pushScopeId("data-v-9f0bb346")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Default Workflows", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Create workflows that will be automatically added to new organizations. This setting will not apply to new organizations that sign up through Geotab or any third party. ", -1)
const _hoisted_3 = { class: "max-width" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_WorkflowArray = _resolveComponent("WorkflowArray")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode(_component_WorkflowArray, {
        modelValue: _ctx.workflows,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workflows = $event)),
        onChanged: _ctx.onWorkflowsChanged
      }, null, 8, ["modelValue", "onChanged"])
    ], 512), [
      [_directive_loading, _ctx.fetchState !== _ctx.FetchStates.FETCHED]
    ])
  ], 64))
})